/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import Query from "../../../Basis/Queries/Query";
import { nameof } from "../../../Basis/Utils/AnyUtil";
import Logo from "./Logo";
import TeilnahmeEinstellungen, { SuchEinstellung } from "./TeilnahmeEinstellungen";

export default class LadeTeilnahmeEinstellungen extends Query<TeilnahmeEinstellungen, any> {
    public static readonly queryName: string = "Teilnahmen_LadeTeilnahmeEinstellungen";
    private static readonly query = gql`
        query ${LadeTeilnahmeEinstellungen.queryName} {
            ${LadeTeilnahmeEinstellungen.queryName} {
                ${nameof<TeilnahmeEinstellungen>("teilnahmeEinstellungenId")}
                ${nameof<TeilnahmeEinstellungen>("rechtliches")}
                ${nameof<TeilnahmeEinstellungen>("rechtlichesEN")}
                ${nameof<TeilnahmeEinstellungen>("schriftart")}
                ${nameof<TeilnahmeEinstellungen>("schriftfarbe")}
                ${nameof<TeilnahmeEinstellungen>("sekundaerfarbe")}
                ${nameof<TeilnahmeEinstellungen>("primaerfarbe")}
                ${nameof<TeilnahmeEinstellungen>("geaendert")}
                ${nameof<TeilnahmeEinstellungen>("logo")} {
                    ${nameof<Logo>("logoBlobId")}
                    ${nameof<Logo>("logoDaten")}
                    ${nameof<Logo>("dateiname")}
                    ${nameof<Logo>("contentType")}
                }
                ${nameof<TeilnahmeEinstellungen>("logoAufHintergrund")} {
                    ${nameof<Logo>("logoBlobId")}
                    ${nameof<Logo>("logoDaten")}
                    ${nameof<Logo>("dateiname")}
                    ${nameof<Logo>("contentType")}
                }
                ${nameof<TeilnahmeEinstellungen>("banner")} {
                    ${nameof<Logo>("logoBlobId")}
                    ${nameof<Logo>("logoDaten")}
                    ${nameof<Logo>("dateiname")}
                    ${nameof<Logo>("contentType")}
                }
                ${nameof<TeilnahmeEinstellungen>("favicon")} {
                    ${nameof<Logo>("logoBlobId")}
                    ${nameof<Logo>("logoDaten")}
                    ${nameof<Logo>("dateiname")}
                    ${nameof<Logo>("contentType")}
                }
                ${nameof<TeilnahmeEinstellungen>("bannerNurAufSucheAnzeigen")}
                ${nameof<TeilnahmeEinstellungen>("anmeldebestaetigungHinweise")}
                ${nameof<TeilnahmeEinstellungen>("anmeldebestaetigungHinweiseEN")}
                ${nameof<TeilnahmeEinstellungen>("eMailHinweise")}
                ${nameof<TeilnahmeEinstellungen>("eMailHinweiseEN")}
                ${nameof<TeilnahmeEinstellungen>("agbUrl")}
                ${nameof<TeilnahmeEinstellungen>("agbUrlEN")}
                ${nameof<TeilnahmeEinstellungen>("datenschutzUrl")}
                ${nameof<TeilnahmeEinstellungen>("datenschutzUrlEN")}
                ${nameof<TeilnahmeEinstellungen>("impressumUrl")}
                ${nameof<TeilnahmeEinstellungen>("impressumUrlEN")}
                ${nameof<TeilnahmeEinstellungen>("fusstext")}
                ${nameof<TeilnahmeEinstellungen>("fusstextEN")}
                ${nameof<TeilnahmeEinstellungen>("homepageTitel")}
                ${nameof<TeilnahmeEinstellungen>("homepageTitelEN")}
                ${nameof<TeilnahmeEinstellungen>("faviconBlobId")}
                ${nameof<TeilnahmeEinstellungen>("suchauswahlImSeitenkopf")}
                ${nameof<TeilnahmeEinstellungen>("sepaVorankuendigungUeberLanCloudVersenden")}
                ${nameof<TeilnahmeEinstellungen>("archivAnzeigen")}
                ${nameof<TeilnahmeEinstellungen>("geschlechtDiversAnzeigen")}
                ${nameof<TeilnahmeEinstellungen>("ustHinweisAnzeigen")}
                ${nameof<TeilnahmeEinstellungen>("anmeldungErforderlich")}
                ${nameof<TeilnahmeEinstellungen>("rechnungsadresseVorbelegen")}
                ${nameof<TeilnahmeEinstellungen>("firmenfeldPriorisieren")}
                ${nameof<TeilnahmeEinstellungen>("teilnahmelistenImDozierendenportalAnzeigen")}
                ${nameof<TeilnahmeEinstellungen>("deutschlandAlsVorauswahl")}
                ${nameof<TeilnahmeEinstellungen>("suchEinstellungen")} {
                    ${nameof<SuchEinstellung>("suchEinstellungId")}
                    ${nameof<SuchEinstellung>("teilnahmeEinstellungenId")}
                    ${nameof<SuchEinstellung>("typ")}
                    ${nameof<SuchEinstellung>("anzeigen")}
                    ${nameof<SuchEinstellung>("istStandard")}
                    ${nameof<SuchEinstellung>("sortierung")}
                }
            }
        }
    `;

    public constructor(onCompleted: (data: TeilnahmeEinstellungen) => void) {
        super(LadeTeilnahmeEinstellungen.query, onCompleted);
    }

    public get name(): string {
        return LadeTeilnahmeEinstellungen.queryName;
    }
}